var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#logo-cgf';
                    var viewUrl = 'sprite.svg#view-logo-cgf';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 139 46',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };